document.addEventListener('DOMContentLoaded', function () {
	const peopleModal = document.getElementById('people-sidebar-section');
	const peopleData = document.querySelectorAll('.people-card');
	const anchorTags = document.querySelectorAll('.list-items a');
	const dropdown = document.getElementById('mobile-jumpto');
	if (dropdown) {
		dropdown.addEventListener('change', function () {
			const selectedOption = dropdown.value;
			const targetElement = document.getElementById(selectedOption);

			if (targetElement) {
				targetElement.scrollIntoView({ behavior: 'smooth' });
			}
		});
	}
	if (anchorTags && anchorTags.length > 0) {
		anchorTags[0].classList.add('active');
		anchorTags.forEach(anchor => {
			anchor.addEventListener('click', function () {
				anchorTags.forEach(a => a.classList.remove('active'));
				anchor.classList.add('active');
			});
		});
	}

	peopleData.forEach(ibPeople => {
		const peopleWrapp = ibPeople.lastChild;
		peopleWrapp.style.display = 'none';
		document.body.classList.remove('scroll-fix');
	});
	peopleData.forEach(people => {
		people.addEventListener('click', event => {
			const peopleWrap = people.lastChild.cloneNode(true);
			peopleModal.appendChild(peopleWrap);
			if (!event.target.closest('.social-icons')) {
				event.preventDefault();
				peopleModal.style.display = 'block';
				peopleWrap.style.display = 'block';
				document.body.classList.add('scroll-fix');
			}
		});
	});

	document.body.addEventListener('click', function (event) {
		if (event.target.closest('.social-icons')) {
			return;
		}
		if (event.target.id === 'close-modal') {
			peopleModal.style.display = 'none';
			peopleModal.children[0].remove();
			document.body.classList.remove('scroll-fix');
		} else if (event.target.id === 'download-modal') {
			const imageUrl = peopleModal.querySelectorAll('#imageToDownload')[0].currentSrc;
			const urlParts = imageUrl.split('/');
			const imageName = urlParts[urlParts.length - 1];
			const downloadLink = document.createElement('a');
			downloadLink.href = imageUrl;
			downloadLink.setAttribute('download', imageName);
			downloadLink.click();
		} else if (event.target.classList.contains('people-modal')) {
			document.body.classList.remove('scroll-fix');
			peopleModal.children[0].remove();
			peopleModal.style.display = 'none';
		}
	});
	document.addEventListener('keydown', function (event) {
		if (event.keyCode === 27) {
			peopleModal.style.display = 'none';
			peopleModal.children[0].remove();
			document.body.classList.remove('scroll-fix');
		}
	});
});
